enum ConditionalSigningStatusEnum {
    AwaitingSignature = 'AWAITING_SIGNATURE',
    Cancelled = 'CANCELLED',
    Expired = 'EXPIRED',
    Failed = 'FAILED',
    PartiallySigned = 'PARTIALLY_SIGNED',
    Signed = 'SIGNED',
}

export default ConditionalSigningStatusEnum;
